<template>
    <div class="progress-container">
      <div 
        class="progress-circle"
        :style="circleStyle"
      >
        <div class="progress-content">
          {{ numerator }}/{{ denominator }}
        </div>
      </div>
      <div class="progress-text">
        {{ title }}
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      numerator: {
        type: Number,
        default: 0
      },
      denominator: {
        type: Number,
        default: 3
      },
      progressColor: {
        type: String,
        default: '#F93C34'
      },
      baseColor: {
        type: String,
        default: '#656A8D'
      },
      title: {
        type: String,
        default: 'Vytvorených ponúk'
      }
    },
    computed: {
      progressPercentage() {
        return Math.min((this.numerator / this.denominator) * 100, 100)
      },
      circleStyle() {
        return {
          '--progress-percentage': `${this.progressPercentage}%`,
          '--progress-color': this.progressColor,
          '--base-color': this.baseColor
        }
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .progress-container {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
  }
  
  .progress-circle {
    width: 45px;
    height: 44px;
    border-radius: 50%;
    background: conic-gradient(
      var(--progress-color) var(--progress-percentage),
      var(--base-color) 0
    );
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .progress-content {
    background: white;
    width: 85%;
    height: 85%;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 600;
    color: #4E5268;
  }
  .progress-text {
    font-family: Montserrat;
    font-size: 16px;
    font-weight: 600;
    color: #4E5268;
  }
  </style>